var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-8 px-10 bg-white shadow-md rounded-lg"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }